import { create } from 'zustand'
import { BonusesSlice, createBonusesSlice } from './slices'

interface LuckySpinsStore {
    isModalOpened: boolean
    setIsModalOpened: (isModalOpened: boolean) => void
    remainingSpins: string
    setRemainingSpins: (remainingSpins: string) => void
    totalWin: string
    setTotalWin: (totalWin: string) => void
    isIntro: boolean
    setIsIntro: (value: boolean) => void
    showRemainingSpinsBanner: boolean
    setShowRemainingSpinsBanner: (shouldShow: boolean) => void
    areLSAboutToStart: boolean
    setAreLSAboutToStart: (aboutToStart: boolean) => void
    isRecovery: boolean
    setIsRecovery: (isRecovery: boolean) => void
    showLuckySpins: boolean
    setShowLuckySpins: (value: boolean) => void
    // LS are first awarded and then on the second bet triggered
    // areLSAwarded is true right before the triggering bet starts the LS
    areLSAwarded: boolean
    setAreLSAwarded: (areLSAwarded: boolean) => void
}

export const useLuckySpinsStore = create<LuckySpinsStore & BonusesSlice>((set) => ({
    isRecovery: false,
    setIsRecovery: (isRecovery: boolean) => {
        set({ isRecovery })
    },
    isModalOpened: false,
    setIsModalOpened: (isModalOpened) => {
        set({ isModalOpened })
    },
    remainingSpins: '0',
    setRemainingSpins: (remainingSpins) => {
        set({ remainingSpins })
    },
    ...createBonusesSlice(set),
    isIntro: false,
    setIsIntro: (value) => set({ isIntro: value }),
    showRemainingSpinsBanner: false,
    setShowRemainingSpinsBanner: (shouldShow: boolean) => set({ showRemainingSpinsBanner: shouldShow }),
    areLSAboutToStart: false,
    setAreLSAboutToStart: (aboutToStart: boolean) => set({ areLSAboutToStart: aboutToStart }),
    showLuckySpins: false,
    setShowLuckySpins: (value: boolean) => set({ showLuckySpins: value }),
    areLSAwarded: false,
    setAreLSAwarded: (areLSAwarded: boolean) => set({ areLSAwarded }),
}))
